import { CURRENT_YEAR, MAIN_PLL_URL } from '../../../Config/League/league.config'
import { SEASON_SEGMENT_NAMES } from '../../../Constants/season'
import { ASG_TEAM_LOGO_IMAGES, TEAM_LOGO_IMAGES } from '../../../Constants/team'
import { SeasonType } from '../../../Context/SeasonContext/SeasonContext'
import { getFullTeamName, getGeneralTeamIc } from '../../../Utils/TeamHelpers/teamHelpers'

/**
 * Get team image checking for allstar season or regular season
 * @param teamName - Team name
 * @param year - Year
 * @param segment - Season segment
 * @returns Team image
 */
export const getTeamImage = (
  teamName: string,
  year?: number,
  segment?: SeasonType | undefined
): string => {
  if (segment === SEASON_SEGMENT_NAMES.allstar) {
    return getAsgTeamIc(teamName, year ?? CURRENT_YEAR)
  }
  return getTeamIc(teamName, year)
}

/**
 * Get team image for regular season
 * @param teamName - Team name
 * @param year - Year
 * @returns Team image
 */
export const getTeamIc = (teamName: string | undefined, year?: number): string => {
  if (!teamName) return getGeneralTeamIc()
  const yr = year ?? CURRENT_YEAR
  const formattedTeam = formatTeamForImage(teamName)

  if (!formattedTeam) return getGeneralTeamIc()

  if (yr < 2024 && yr >= 2019) {
    return `https://${MAIN_PLL_URL}/${formattedTeam}_primary_fullcolor`
  }
  if (yr < 2019) {
    return getGeneralTeamIc()
  }
  return TEAM_LOGO_IMAGES[formattedTeam] ?? getGeneralTeamIc()
}

/**
 * Get team image for allstar season
 * @param teamName - Team name
 * @param year - Year
 * @returns Team image
 */
export const getAsgTeamIc = (teamName: string | undefined, year: number): string => {
  if (!teamName) return getGeneralTeamIc()
  const yearStr = year.toString()
  const formattedTeam = formatTeamForImage(teamName)
  if (!formattedTeam) return getGeneralTeamIc()

  const yearData = ASG_TEAM_LOGO_IMAGES[yearStr]
  if (!yearData) return getTeamIc(teamName, year)
  return yearData[formattedTeam] ?? getTeamIc(teamName, year)
}

/**
 * Convert team code and format team name for image
 * @param teamName - Team name
 * @returns Formatted team name
 */
const formatTeamForImage = (teamName: string): string => {
  if (!teamName) return ''
  let processedName = teamName
  if (teamName.length <= 4) {
    const fullName = getFullTeamName(teamName)
    if (fullName) {
      processedName = fullName
    }
  }
  return processedName.toLowerCase()
}
